/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  noResultContainer: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },

  addBuyerBtn: {
    minWidth: '300px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
});

export default styles;
